/* PNOE Gift Card Bonus / staged cart sync.
   Load only with theme setting ON, after product and discount are verified.
   Shopify Buy X Get Y sets the price. Never invent a zero-price line.
*/
(() => {
  "use strict";
  const params = document.currentScript?.dataset || {};
  const buyId = Number(params.buyVariantId);
  const giftId = Number(params.bonusVariantId);
  if (!Number.isSafeInteger(buyId) || !Number.isSafeInteger(giftId) ||
      buyId <= 0 || giftId <= 0 || buyId === giftId) return;
  const root = (window.Shopify?.routes?.root || "/").replace(/\/?$/, "/");
  const propertyName = "_pnoe_gift_card_bonus";
  let busy = false, pending = false, timeoutId = 0;
  const cartUrl = root + "cart.js";
  const load = async () => {
    const response = await fetch(cartUrl, {credentials:"same-origin",cache:"no-store"});
    if (!response.ok) throw new Error("Could not read cart");
    return response.json();
  };
  const post = async (endpoint, body) => {
    const response = await fetch(root + endpoint, {
      method:"POST", credentials:"same-origin",
      headers:{"Content-Type":"application/json",Accept:"application/json"},
      body:JSON.stringify(body)
    });
    if (!response.ok) throw new Error("Could not update cart");
    return response.json();
  };
  const clearMessage = () => document.getElementById("PnoeBonusCartAlert")?.remove();
  function showMessage() {
    const container=document.querySelector("#Cart-Drawer [data-cart-drawer-content]") ||
      document.querySelector("#Cart-Page [data-cart-page-content]");
    if (!container) return;
    let alert=document.getElementById("PnoeBonusCartAlert");
    if (!alert) {
      alert=document.createElement("p");
      alert.id="PnoeBonusCartAlert";
      alert.className="pnoe-bf-bonus-warning";
      alert.setAttribute("role","status");
      container.prepend(alert);
    }
    const greek=/^el(?:-|$)/i.test(document.documentElement.lang);
    alert.textContent=greek
      ? "Η δωρεάν Gift Card 20€ δεν εφαρμόστηκε. Δεν χρεώθηκε επιπλέον δωροκάρτα. Έλεγξε το καλάθι πριν ολοκληρώσεις."
      : "The free €20 gift card could not be applied. No paid bonus card was kept. Review your cart before checkout.";
  }
  const getPromos = cart => (cart.items || []).filter(item =>
    Number(item.variant_id) === giftId && String(item.properties?.[propertyName]) === "1");
  const quantity = items => items.reduce((n,item)=>n+(Number(item.quantity)||0),0);
  async function refresh(cart) {
    const component = document.querySelector("cart-items");
    if (component?.getSectionsToRender && component?.renderSections) {
      const sections = [...new Set(component.getSectionsToRender().map(x=>x.section))];
      if (sections.length) {
        const response = await fetch(root + "?sections=" + encodeURIComponent(sections.join(",")), {
          credentials:"same-origin",cache:"no-store"
        });
        if (response.ok) component.renderSections(await response.json());
      }
    }
    document.dispatchEvent(new CustomEvent("cart:updated", {detail:{cart,source:"pnoe-gift-card-bonus"}}));
  }
  async function sync() {
    if (busy) {pending=true;return;}
    busy=true;
    try {
      clearMessage();
      const cart=await load();
      const wanted=quantity((cart.items||[]).filter(item=>Number(item.variant_id)===buyId));
      const promos=getPromos(cart);
      const existing=quantity(promos);
      if (wanted === existing) return;
      if (wanted > existing) {
        await post("cart/add.js", {items:[{
          id:giftId,quantity:Math.min(100,wanted-existing),
          properties:{[propertyName]:"1"}
        }]});
      } else {
        const updates={};
        let keep=wanted;
        promos.forEach(item=>{
          const allowed=Math.min(Number(item.quantity)||0,keep);
          updates[item.key]=allowed;
          keep-=allowed;
        });
        if (Object.keys(updates).length) await post("cart/update.js",{updates});
      }
      let updated=await load();
      const unpaid=getPromos(updated).filter(item => Number(item.final_line_price)>0);
      if (unpaid.length) {
        const updates={};
        unpaid.forEach(item=>{updates[item.key]=0;});
        await post("cart/update.js",{updates});
        updated=await load();
        showMessage();
        document.dispatchEvent(new CustomEvent("pnoe:gift-bonus-unavailable",{
          detail:{message:"Bonus not free; the paid bonus gift card was removed"}
        }));
      }
      await refresh(updated);
    } catch (error) {
      showMessage();
      console.warn("PNOE Gift Card Bonus sync:",error?.message||error);
    } finally {
      busy=false;
      if (pending) {pending=false;queue();}
    }
  }
  function queue(event) {
    if(event?.detail?.source==="pnoe-gift-card-bonus") return;
    clearTimeout(timeoutId);
    timeoutId=setTimeout(()=>{void sync();},280);
  }
  ["cart-update","cart:updated","quantity-update","cart:refresh"].forEach(
    name=>document.addEventListener(name,queue)
  );
  document.addEventListener("click",event=>{
    if(event.target.closest("[data-add-to-cart],[data-cart-remove],[name=plus],[name=minus]")){
      setTimeout(queue,850);
    }
  },{passive:true});
  if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",queue,{once:true});
  else queue();
  addEventListener("pageshow",queue);
})();
